import { createContext } from "react";
const CardViewContext = /*#__PURE__*/createContext({
  cellDecorator: props => props
});
export default CardViewContext;